import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import HotRank from './components/HotRank';
import Rising from './components/Rising';
import CategoryGrid from './components/CategoryGrid';
import Editorial from './components/Editorial';
import Faq from './components/Faq';
import About from './components/About';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import { FAQS } from '@/mocks/trending';

const SITE_URL = 'https://kangyifan.cn/';

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 720);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '快瓜 Gua Radar',
    url: SITE_URL,
    slogan: '全网热榜聚合与吃瓜资讯，第一时间吃到第一口瓜',
    logo: SITE_URL,
  };
  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '快瓜 Gua Radar',
    url: SITE_URL,
    inLanguage: 'zh-CN',
  };
  const webpage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '快瓜 · 全网热榜实时聚合',
    url: SITE_URL,
    isPartOf: { '@type': 'WebSite', name: '快瓜 Gua Radar', url: SITE_URL },
    inLanguage: 'zh-CN',
    description:
      '快瓜实时聚合全网热榜与飙升话题，爆瓜预警第一时间触发，热度曲线一图看懂舆论风向。覆盖娱乐、社会、体育、财经与科技。',
  };
  const faq = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organization) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(website) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpage) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faq) }} />

      <Header />
      <main>
        <Hero />
        <Ticker />
        <HotRank />
        <Rising />
        <CategoryGrid />
        <Editorial />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          title="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm transition hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
        </a>
      )}
    </>
  );
}